import { render, staticRenderFns } from "./houseDetail.vue?vue&type=template&id=68582ab3&"
import script from "./houseDetail.vue?vue&type=script&lang=js&"
export * from "./houseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports